// VinithaDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import vinithadoc from '../../../../assets/images/Doctorsimages/vinithadr.jpeg'
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const VinithaDoc = () => {
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Vinitha Gopi | Expert Homoeopathic & Aesthetic Consultant in Salem";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Vinitha Gopi (BHMS, PGDCC), a Senior Consultant specializing in Homeopathy and Aesthetic Cosmetology in Salem. With 4+ years of experience, she provides holistic and advanced skin, hair, and wellness treatments. Book your appointment today."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best homeopathy doctor in Salem, aesthetic doctor in Salem, homoeopathic consultant in Salem, female homeopathy doctor Salem, clinical cosmetology expert Salem, skin and hair treatment Salem, holistic homeopathic healing Salem, advanced aesthetic treatments Salem, senior homeopathic consultant, root cause treatment Salem"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-vinitha-gopi-homeopathy-aesthetic-consultant-salem-tamilnadu");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-vinitha-gopi-homeopathy-aesthetic-consultant-salem-tamilnadu");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });
    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10;
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }
      pdf.save('Dr.Vinitha_Gopi_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Vinitha Gopi</span>
                  <span className="veenadoc-title-credentials">(BHMS, PGDCC)</span>
                  <span className="veenadoc-title-location">Salem</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A highly skilled Senior Consultant who bridges the gap between traditional holistic healing and modern 
                    aesthetic science. Based in Salem, she provides a unique dual approach to health and beauty with 
                    <strong> 4</strong> years of dedicated clinical experience.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={vinithadoc} alt="Dr. Vinitha Gopi – Senior Aesthetic & Homoeopathic Consultant in Salem" className="veenadoc-doctor-image" title='Dr. Vinitha Gopi – Senior Aesthetic & Homoeopathic Consultant in Salem' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Vinitha Gopi</h2>
                  <p>
                    Dr. Vinitha Gopi earned her BHMS degree from the prestigious Vinayaka Mission’s Homoeopathic Medical College 
                    & Hospital, Salem. To further her passion for skin and hair care, she pursued a Post Graduate Diploma in 
                    Clinical Cosmetology (PGDCC) from IICS Salem.
                  </p>
                  <p>
                    This specialized training allows her to integrate advanced aesthetic procedures with the gentle, 
                    deep-acting benefits of homoeopathy, establishing her as a trusted professional for patients 
                    seeking safe, ethical, and long-lasting results.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Experience</h2>
                  <p>
                    Throughout her career, Dr. Vinitha has served as a Clinic Consultant at the Sri Vaari Homoeopathic 
                    Clinic in Salem. As a Senior Consultant Doctor, she has managed a wide range of clinical cases, 
                    helping patients address chronic health conditions while offering sophisticated aesthetic solutions.
                  </p>
                  <p>
                    Her four years of practice are marked by a deep commitment to patient welfare and a reputation for 
                    providing personalized care that respects the individual needs of every patient.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, PGDCC</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">4 Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Role:</span>
                      <span className="veenadoc-info-value">Senior Consultant</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Salem</span>
                    </div>
                  </div>
                </div>

                {/* Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Expertise in Homeopathy & Cosmetology</h2>
                  <p>
                    Dr. Vinitha specializes in treating the underlying triggers of skin and hair issues. Whether dealing 
                    with persistent skin conditions, hair thinning, or lifestyle-related health problems, she uses her 
                    dual expertise to create a comprehensive treatment plan.
                  </p>
                  <p>
                    By addressing the root cause rather than just the symptoms, she helps her patients achieve a state 
                    of health that reflects outwardly as natural confidence and radiance.
                  </p>
                </div>

                {/* Patient Experience */}
                <div className="veenadoc-article-block">
                  <h2>A Trusted Name in Salem</h2>
                  <p>
                    Patients seeking an aesthetic doctor in Salem often choose Dr. Vinitha because of her ethical 
                    approach and reliance on safe, proven methods. She believes in enhancing natural features 
                    through advanced cosmetology while ensuring internal health is supported by homoeopathic principles.
                  </p>
                  <p>
                    Her dedication to continuous learning and her focus on "root cause" healing set her apart in 
                    the fields of homoeopathy and cosmetology, providing a comfortable and empathetic environment.
                  </p>
                </div>

                 <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Vinitha Gopi has gained recognition as a trichology doctor in Salem specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Vinitha Gopi for Complete Wellness</h2>
                  <p>
                    Choosing Dr. Vinitha Gopi means selecting a doctor who is committed to your complete health and 
                    well-being. For patients in Salem looking for a doctor who treats the whole person—mind, body, 
                    and skin—she offers the perfect blend of trust, expertise, and excellence.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To provide healthy, confident, and long-lasting results through 
                    personalized, safe, and ethical care.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "I combine holistic homoeopathic healing with advanced aesthetic cosmetology to enhance natural beauty and overall wellness."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Vinitha Gopi's Philosophy</p>
                  </div>
                  <p>
                    Her approach focuses on treating the root cause with personalized, safe, and ethical care to 
                    ensure genuine healing that starts from within.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Salem, Tamil Nadu</h4>
                      <p>Sri Vaari Homoeopathic Clinic</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience the blend of holistic healing and advanced aesthetics with Dr. Vinitha.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default VinithaDoc
